module.exports = __webpack_public_path__ + "static/media/showroom-background-2.5cc6116d.jpg";